import {createAsyncThunk,createSlice} from "@reduxjs/toolkit";

const initialState={
    visitorList:[],
    visitorSummaryList:[],
    selectedVisitor:null,
    selectedVisitorSummary:null,
    status:"idle",
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    error:''
}

export const fetchVisitors=createAsyncThunk('visitors/fetchVisitors', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/apages/visitor/all',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchVisitorsById=createAsyncThunk('visitors/fetchVisitorById', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/apages/visitor/getVisitorById/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchVisitorSummaryById=createAsyncThunk('visitors/fetchVisitorSummaryById', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/apages/visitor/getVisitorByIdSummary/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchVisitorByUUID = createAsyncThunk('visitors/fetchVisitorByUUID', async (uuid)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/apages/visitor/getVisitorByUUID/${uuid}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const CreateVisitor = createAsyncThunk('visitors/createVisitor', async (visitorData)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/apages/visitor/create',
        {
            method:'POST',
            body: JSON.stringify(visitorData),
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            }
        }
    )
    return response.json()
})

export const UpdateVisitorAction = createAsyncThunk('visitors/updateVisitor', async ({action,visitorId})=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/apages/visitor/update/${action}/${visitorId}`,
        {
            method:'GET',
            //body: JSON.stringify({action,visitorId}),
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            }
        }
    )
    return response.json()
})

export const DeleteVisitorById = createAsyncThunk('visitors/deleteVisitorById', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/apages/visitor/deleteVisitorById/${id}`,
        {
            method:'GET',
            //body: JSON.stringify({sessionId:id}),
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            }
        }
    )
    return response.json()
})

const visitorSlice = createSlice({
    name: "visitors",
    initialState,
    reducers: {
        changeRegisterStatus: (state) => {
            state.registerstatus = 'failure';
        },
        changeEditStatus: (state) => {
            state.editstatus = 'failure';
        },
        changeDeleteStatus:(state)=>{
            state.deletestatus='failure';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVisitors.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchVisitors.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.visitorList = action.payload;
            })
            .addCase(fetchVisitors.rejected, (state, action) => {
                state.status = 'error';
                state.error = state.error.message || 'Failed to fetch visitors';
            })
            .addCase(fetchVisitorsById.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchVisitorsById.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.selectedVisitor = action.payload;
            })
            .addCase(fetchVisitorsById.rejected, (state, action) => {
                state.status = 'error';
                state.error = state.error.message || 'Failed to fetch visitors';
            })
            .addCase(fetchVisitorSummaryById.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchVisitorSummaryById.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.selectedVisitorSummary = action.payload;
            })
            .addCase(fetchVisitorSummaryById.rejected, (state, action) => {
                state.status = 'error';
                state.error = state.error.message || 'Failed to fetch visitors';
            })
            .addCase(CreateVisitor.pending,(state)=>{
                state.registerstatus='loading';
            })
            .addCase(CreateVisitor.fulfilled,(state, action)=>{
                state.registerstatus='succeeded';
            })
            .addCase(CreateVisitor.rejected, (state, action) => {
                state.registerstatus = 'error';
                state.error = state.error.message || 'Failed to fetch products';
            })
            .addCase(UpdateVisitorAction.pending,(state)=>{
                state.editstatus='loading';
            })
            .addCase(UpdateVisitorAction.fulfilled,(state, action)=>{
                state.editstatus='succeeded';
            })
            .addCase(UpdateVisitorAction.rejected, (state, action) => {
                state.editstatus = 'error';
                state.error = state.error.message || 'Failed to fetch products';
            })
            .addCase(DeleteVisitorById.pending,(state)=>{
                state.deletestatus='loading';
            })
            .addCase(DeleteVisitorById.fulfilled,(state, action)=>{
                state.deletestatus='succeeded';
            })
            .addCase(DeleteVisitorById.rejected, (state, action) => {
                state.deletestatus = 'error';
                state.error = state.error.message || 'Failed to fetch products';
            })
            .addCase(fetchVisitorByUUID.pending,(state)=>{
                state.status='loading';
            })
            .addCase(fetchVisitorByUUID.fulfilled,(state, action)=>{
                state.status='succeeded';
                state.selectedVisitor = action.payload;
            })
            .addCase(fetchVisitorByUUID.rejected, (state, action) => {
                state.status = 'error';
                state.error = state.error.message || 'Failed to fetch products';
            })
    }
})
export default visitorSlice.reducer;
